import React from 'react';

function EllipseIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
    >
      <path
        d="M18.9475 10.5C19.5288 10.5 20.0057 10.9725 19.9447 11.5505C19.775 13.1569 19.2179 14.7039 18.3147 16.0557C17.2159 17.7002 15.6541 18.9819 13.8268 19.7388C11.9996 20.4957 9.98891 20.6937 8.0491 20.3079C6.10929 19.922 4.32746 18.9696 2.92893 17.5711C1.53041 16.1725 0.577999 14.3907 0.192147 12.4509C-0.193705 10.5111 0.00432836 8.50043 0.761205 6.67317C1.51808 4.8459 2.79981 3.28412 4.4443 2.1853C5.79607 1.28208 7.34305 0.725022 8.94945 0.555328C9.52749 0.494266 10 0.971202 10 1.55246C10 2.13371 9.52673 2.5977 8.95063 2.67496C7.76131 2.83445 6.61913 3.26369 5.61373 3.93548C4.31539 4.803 3.30345 6.03604 2.70589 7.47868C2.10833 8.92132 1.95198 10.5088 2.25662 12.0403C2.56125 13.5718 3.31319 14.9785 4.41733 16.0827C5.52148 17.1868 6.92825 17.9387 8.45975 18.2434C9.99124 18.548 11.5787 18.3917 13.0213 17.7941C14.464 17.1965 15.697 16.1846 16.5645 14.8863C17.2363 13.8809 17.6655 12.7387 17.825 11.5494C17.9023 10.9733 18.3663 10.5 18.9475 10.5Z"
        fill="#FF8A00"
      />
    </svg>
  );
}

export default EllipseIcon;
